import { create } from "zustand"
import { persist } from "zustand/middleware"
import type { SummaryRow, BackendRun } from "@/types"

interface AppState {
  // UI
  sidebarOpen: boolean
  setSidebarOpen: (open: boolean) => void
  theme: "dark" | "light"
  setTheme: (theme: "dark" | "light") => void

  // Backend data (AeroRL Bench API)
  summary: SummaryRow[] | null
  setSummary: (s: SummaryRow[]) => void
  runs: BackendRun[]
  setRuns: (r: BackendRun[]) => void
  selectedRunId: number | null
  setSelectedRunId: (id: number | null) => void

  // Live simulation
  simStatus: "idle" | "running" | "paused" | "completed" | "aborted"
  setSimStatus: (s: AppState["simStatus"]) => void
  simTelemetry: any[] | null
  setSimTelemetry: (t: any[] | null) => void
  simCurrent: any | null
  setSimCurrent: (c: any | null) => void
  simMetrics: any | null
  setSimMetrics: (m: any | null) => void
  simLogs: string[]
  setSimLogs: (logs: string[]) => void
  addSimLog: (log: string) => void
  simDuration: number
  setSimDuration: (d: number) => void
  simReset: () => void
}

export const useAppStore = create<AppState>()(
  persist(
    (set) => ({
      sidebarOpen: true,
      setSidebarOpen: (open) => set({ sidebarOpen: open }),
      theme: "dark",
      setTheme: (t) => set({ theme: t }),
      summary: null,
      setSummary: (s) => set({ summary: s }),
      runs: [],
      setRuns: (r) => set({ runs: r }),
      selectedRunId: null,
      setSelectedRunId: (id) => set({ selectedRunId: id }),
      simStatus: "idle",
      setSimStatus: (s) => set({ simStatus: s }),
      simTelemetry: null,
      setSimTelemetry: (t) => set({ simTelemetry: t }),
      simCurrent: null,
      setSimCurrent: (c) => set({ simCurrent: c }),
      simMetrics: null,
      setSimMetrics: (m) => set({ simMetrics: m }),
      simLogs: [],
      setSimLogs: (logs) => set({ simLogs: logs }),
      addSimLog: (log) =>
        set((state) => ({
          simLogs: [...state.simLogs.slice(-200), log],
        })),
      simDuration: 0,
      setSimDuration: (d) => set({ simDuration: d }),
      simReset: () =>
        set({
          simStatus: "idle",
          simTelemetry: null,
          simCurrent: null,
          simMetrics: null,
          simLogs: [],
          simDuration: 0,
        }),
    }),
    { name: "rocketlab-storage", partialize: (state) => ({ theme: state.theme }) },
  ),
)
